export const resolveCardIcon = (cardNumber) => {
  if (!cardNumber) return null;

  const clean = cardNumber.replace(/\*/g, '');

  // VISA
  if (/^4/.test(clean)) return 'cards-visuals-visa';

  // MASTERCARD (51–55, 2221–2720 partial safe match)
  if (/^5[1-5]/.test(clean) || /^2(2[2-9]|[3-6]|7[01])/.test(clean)) {
    return 'cards-visuals-mastercard';
  }

  // AMEX
  if (/^3[47]/.test(clean)) return 'cards-visuals-amex';

  // DISCOVER
  if (/^6/.test(clean)) return 'cards-visuals-discover';

  // DINERS
  if (/^(30[0-5]|36|38)/.test(clean)) {
    return 'cards-visuals-diners';
  }

  // JCB
  if (/^35/.test(clean)) return 'cards-visuals-jcb';

  // MAESTRO
  if (/^(5018|5020|5038|56|57|58|6304|6759|6761|6763)/.test(clean)) {
    return 'cards-visuals-maestro';
  }

  return 'credit-card-mono';
};
